export const environment = {
  production: false,
  i18nPrefix: 'assets/i18n/',
  token: ``,
  env: 'dev',
  AMPLITUDE_KEY: 'f51980809bf7dfd7d17f388a5f5dae61',
  server: {
    entitlementServiceAdmin: {
      hosted: false,
      url: ''
    }
  },
  gateway_endpoint: 'https://api.dev.pro.interact-lighting.com',
  webcomponent_endpoint: 'https://dev.sme.interact-lighting.com/Gatewayapi',
  portal_api_endpoint: 'https://dev.sme.interact-lighting.com'
};
